// Automatic colour mode uses Nautilus task states and native roadmap groups.
export const STATUSES = ['planned', 'progress', 'done'];
export const STATUS_LABELS = { planned: 'Planned', progress: 'In progress', done: 'Done' };
export const STATUS_COLORS = { planned: 'slate', progress: 'blue', done: 'green' };
export const COLOR_MODES = ['standard', 'status'];
export const ownStatus = (item) => (STATUSES.includes(item?.status) ? item.status : 'planned');

// Map the status values supplied by the Nautilus host, not Jira categories.
export const taskStatus = (status) => {
  if (status === 'done') return 'done';
  if (status === 'progress' || status === 'review') return 'progress';
  return 'planned';
};

// A linked task dictates status when available. Otherwise groups derive it from
// children, and standalone items keep the status selected in the roadmap.
// Missing task IDs must not erase a user's manually selected status.
export const statusSource = (item, items, taskStatuses = {}) => {
  if (item.taskId && Object.hasOwn(taskStatuses, String(item.taskId))) {
    return { status: taskStatus(taskStatuses[String(item.taskId)]), from: 'task' };
  }
  const children = item.isGroup ? items.filter((child) => child.parentId === item.id) : [];
  if (!children.length) return { status: ownStatus(item), from: 'item' };
  const statuses = children.map((child) => statusSource(child, items, taskStatuses).status);
  const status = statuses.every((value) => value === 'done') ? 'done' : statuses.every((value) => value === 'planned') ? 'planned' : 'progress';
  return { status, from: 'subitems' };
};
